import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsViewsCountByNavigationTab = _resolveComponent("StatisticsViewsCountByNavigationTab")!

  return (_openBlock(), _createBlock(_component_StatisticsViewsCountByNavigationTab, {
    filter: _ctx.filter,
    firstStorePaths: _ctx.firstStorePaths,
    secondStorePaths: _ctx.secondStorePaths
  }, null, 8, ["filter", "firstStorePaths", "secondStorePaths"]))
}